import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import DollStory from "@/pages/DollStory";
import Curator from "@/pages/Curator";
import Login from "@/pages/Login";
import Photography from "@/pages/Photography";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/dolls/:id" element={<DollStory />} />
            <Route path="/photography" element={<Photography />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/curator"
              element={
                <ProtectedRoute>
                  <Curator />
                </ProtectedRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
